import React from 'react';
import { DatePicker, Col, Form } from 'antd';
import PropTypes from 'prop-types';

export default class DatePickerRange extends React.Component {
  constructor(props) {
    super(props);
    const value = props.value || {};
    this.state = {
      tuNgay: value.tuNgay || undefined,
      denNgay: value.denNgay || undefined
    };
  }

  disabledStartDate = (tuNgay) => {
    if (tuNgay) {
      const { denNgay } = this.state;
      if (!tuNgay || !denNgay) {
        return false;
      }
      return tuNgay.valueOf() > denNgay.valueOf();
    }
    return undefined;
  }

  disabledEndDate = (denNgay) => {
    const { tuNgay } = this.state;
    if (!denNgay || !tuNgay) {
      return false;
    }
    return denNgay.valueOf() <= tuNgay.valueOf();
  }

  onChangeStart = (tuNgay, name) => {
    if (tuNgay) {
      this.setState({
        [name]: tuNgay
      }, () => this.triggerChange({ tuNgay }));
    }
  }

  onChangeEnd = (denNgay, name) => {
    this.setState({
      [name]: denNgay
    }, () => this.triggerChange({ denNgay }));
  }

  triggerChange = (changedValue) => {
    const { onChange } = this.props;
    if (onChange) {
      onChange({ ...this.state, ...changedValue });
    }
  }

  render() {
    const { state } = this;
    const { type } = this.props;
    if (type === 'search') {
      return (
        <>
          <Col md={12} xs={24}>
            <Form.Item label="Từ ngày">
              <DatePicker
                style={{ width: '100%' }}
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...this.props}
                className={this.props.className}
                disabledDate={(value) => this.disabledStartDate(value)}
                format="DD/MM/YYYY"
                onChange={(value) => this.onChangeStart(value, 'tuNgay')}
                placeholder="Từ ngày"
                showToday={false}
                value={state.tuNgay}
              />
            </Form.Item>

          </Col>
          <Col md={12} xs={24}>
            <Form.Item label="Đến ngày">
              <DatePicker
                style={{ width: '100%' }}
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...this.props}
                className={this.props.className}
                disabledDate={(value) => this.disabledEndDate(value)}
                format="DD/MM/YYYY"
                onChange={(value) => this.onChangeEnd(value, 'denNgay')}
                placeholder="Đến ngày"
                showToday={false}
                value={state.denNgay}
              />
            </Form.Item>
          </Col>
        </>
      );
    }
    return (
      <>
        <DatePicker
          style={{ minWidth: 160 }}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...this.props}
          className={this.props.className}
          disabledDate={(value) => this.disabledStartDate(value)}
          format="DD/MM/YYYY"
          onChange={(value) => this.onChangeStart(value, 'tuNgay')}
          placeholder="Từ ngày"
          showToday={false}
          value={state.tuNgay}
        />
        <DatePicker
          style={{ minWidth: 160, paddingLeft: '10px' }}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...this.props}
          className={this.props.className}
          disabledDate={(value) => this.disabledEndDate(value)}
          format="DD/MM/YYYY"
          onChange={(value) => this.onChangeEnd(value, 'denNgay')}
          placeholder="Đến ngày"
          showToday={false}
          value={state.denNgay}
        />
      </>
    );
  }
}

DatePickerRange.propTypes = {
  value: PropTypes.objectOf(PropTypes.any),
  onChange: PropTypes.func,
  className: PropTypes.string,
  type: PropTypes.string
};

DatePickerRange.defaultProps = {
  value: undefined,
  onChange: () => { },
  className: '',
  type: ''
};
